import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-picking-group-sell-order-header',
  templateUrl: './picking-group-sell-order-header.component.html',
  styleUrls: ['./picking-group-sell-order-header.component.scss']
})
export class PickingGroupSellOrderHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
